
export default {
  name: 'review-manage',
  data: function data() {
    return {
      activeIndex: 'auth'
    };
  },
  created: function created() {
    // 根据地址定位活动标签
    this.activeIndex = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1);
  }
};